import ApiService from './ApiService';

class HoggaxService {
  static async sendHoggaxQuoteRequest(payload) {
    const composedURL = `/portals/zonaprop/guarantee_email/`;
    const response = await ApiService.post(composedURL, payload);
    return response;
  }

  static async getPropertyStarredContacts(id) {
    const composedURL = `/api3/properties/${id}/starred_contacts`;
    const response = await ApiService.get(composedURL);
    return response;
  }
}
export default HoggaxService;
